export default {
   // Fonts
   fonts: {
      portrait: 'Portrait, sans-serif',
      sohne: 'Sohne, sans-serif',
   },
   // Mode
   darkMode: false,

   // Colors
   colors: {
      accent: '#172A41',
      accent_300: '#D8D8D8',
      accent_120: 'rgba(23, 42, 65, 0.12)',
      grey_300: 'rgba(255,255,255,0.3)',
      grey_1: '#fafafa',
      grey_2: '#c1c1c1',
      grey_3: '#f6f6f6',
      hotCinnamon: '#FF8921',

      // Buttons:
      btnBgDisabled: '#FAFAFA',
      btnColorDisabled: '#C1C1C1',

      // Light variant
      btnDarkBg: '#1D3654',
      btnDarkBgHover: '#182F4B',
      btnDarkBgFocus: '#102135',
      btnDarkColor: '#fff',

      // Dark variant
      btnLightBg: '#fafafa',
      btnLightColor: '#172A41',
      btnLightBgHover: '#F0F0F0',
      btnLightBgFocus: '#E3E3E3',

      // Orange variant
      btnOrangeBg: '#FF8921',
      btnOrangeBgDisabled: '#CF6C15',
      btnOrangeColor: '#FFFFFF',
      btnOrangeBgHover: '#E2781A',
      btnOrangeBgFocus: '#CF6C15',

      // Outline variant
      btnOutlineBg: '#FFFFFF',
      btnOutlineBorderBg: '#D8D8D8',
      btnOutlineColor: '#172A41',
      btnOutlineBgHover: '#F5F5F5',
      btnOutlineBgFocus: '#EBEBEB',

      // Input
      newsletterInputBg: '#FAFAFA',
      inputBg: '#FFFFFF',
      inputPlaceholderColor: '#C1C1C1',
      inputColor: '#172A41',
      inputBorder: '#D8D8D8',
      inputFocusedBorder: '#172A41',

      // Header:
      headerBtnBgOpen: '#172A41',
      headerBtnBgClose: '#FAFAFA',
      headerBtnColor: '#172A41',
      headerBtnHoverBg: '#172A41',
      headerBtnHoverColor: '#FFF',
      mobileNavBg: '#fafafa',

      // Filters:
      filterBg: 'transparent',
      filterColor: '#172A41',
      filterBorder: '#D8D8D8',
      filterHoverBg: '#FAFAFA',
      filterDisabledColor: 'rgba(23, 42, 65, 0.5)',
      filterDisabledBorder: 'rgba(193, 193, 193, 0.5)',

      // Socials:
      socialBg: '#FAFAFA',
      socialColor: '#172A41',
      socialBorder: '#D8D8D8',
      socialHoverBg: '#172A41',
      socialHoverColor: '#FAFAFA',
      socialHoverBorder: '#172A41',

      error: '#ED4337',
      success: '#55c728',
      white: '#fff',
      black: '#000',
      dark: '#222222',
      darker: '#2b2c2f',
      grey: '#c9c9c9',
      blue: '#0f609b',

      grey_4: '#EFEEEE',
      grey_5: '#F7F7F7',
      grey_6: '#252729',

      socialIcon: '#172A41',
      socialIconBg: '#FAFAFA',
      socialIconBorder: '#D8D8D8',
      button: '#b1b1b1',
      // inputBorder: '#979797',
      categoryColor: '#4098d7',
      sliderBulletBg: '#d8d8d8',
      sliderBulletActiveBg: '#4098d7',
      paginationBullet: '#4a4a4a',
      paginationBulletActive: '#4098d7',
      tabLabel: '#9b9b9b',
      facebook: '#3b5998',
      twitter: '#1da1f2',
      email: '#dd4b39',
      reddit: '#ff4500',
      telegram: '#0088cc',
      linkedin: '#0077b5',
      wechat: '#5cc928',
      copyToClipboard: '#8e41c5',
      hrBg: '#979797',

      // dark mode off
      mainBG: '#fafafa',
      lightGreyBg: '#fff',
      textColor: '#172a41',
      header: '#172a41',
      border: '#979797',
      buttonTextColor: '#515151',
      menuBg: '#FFF',
      menuLogo: '#102a43',
      menuOverlay: '#fafafa',
      hamburger: '#fafafa',
      inputPlaceholder: '#c1c1c1',
      searchInputPlaceholder: '#c1c1c1',
      searchInputColor: '#172a41',
      tabLabelActive: '#222222',
      progressBarBg: '#fff',
      hoveredButtonBg: '#486580',
      hoveredButtonShadow: 'rgba(104, 172, 221, 0.5)',
      selectArrowBg: 'transparent',
      headerNavLinks: '#172a41',
      dropdownListLinks: '#172a41',
      dropdownShadow: '0 2px 20px 0px rgba(183,183,183,0.12), rgba(183,183,183,0.86) 0px 2px 20px 12px',

      hoverLink: '#f5a623',
      bismark: '#486580',
      elephant: '#102a43',
      separator: '#4a4a4a',
      headingNavProjects: '#222222',
      postBoxShadow: 'rgba(183, 183, 183, 0.86) 0px 10px 24px;',
      subscribeBoxBgGradient: 'linear-gradient(0deg, rgba(16, 42, 67, 1) 0%, rgba(126, 158, 183, 1) 100%);',
      subscribeBoxBgSolid: 'rgb(16, 42, 67)',
      subscribeBoxMedia: '#f2f2f3',
      youtubeButtonShadow: '#dedede',
      quoteBg: '#f7f7f7',
      quoteText: '#222222',
      searchPopupBg: '#486580',
      subscribeBoxPodcast: '#f2f2f3',

      mccBlue: '#102A43',
      disclosure: '#808080',
   },
   transitions: {
      main: '0.3s cubic-bezier(0, 0.89, 0.44, 1)',
   },

   // GRID
   space: [0, 5, 10, 15, 20],
   breakpoints: ['576px', '640px', '743px', '1025px', '1200px', '1440px'],
}
